import React from 'react'
import PropTypes from 'prop-types'
import { toKebabCase } from 'utils/stringHelpers'
import {
  Column,
  ColumnHairline,
  ColumnHeader,
  ColumnLink,
  ColumnLinksList,
  ColumnTitle,
  ColumnsWrapper,
} from './multiColumnLinkPanel.styles'

const MultiColumnLinkPanel = ({
  columns,
  dataTestId,
  highlightedOptionId,
  onSelect,
}) => (
  <ColumnsWrapper>
    {columns.map(({ id, label, links }) => (
      <Column key={id}>
        <ColumnHeader>
          <ColumnTitle>{label}</ColumnTitle>
          <ColumnHairline />
        </ColumnHeader>
        <ColumnLinksList>
          {links.map(link => (
            <ColumnLink
              className={
                highlightedOptionId === link.id ? 'arrow-selected' : undefined
              }
              data-testid={`${dataTestId}-${id}-${toKebabCase(
                link.id || link.buttonText,
              )}`}
              key={`${id}-${link.id || link.buttonText}`}
              onClick={() => onSelect(link)}
              tabIndex={-1}
              type="button"
            >
              {link.buttonText}
            </ColumnLink>
          ))}
        </ColumnLinksList>
      </Column>
    ))}
  </ColumnsWrapper>
)

MultiColumnLinkPanel.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      links: PropTypes.array.isRequired,
    }),
  ).isRequired,
  dataTestId: PropTypes.string,
  highlightedOptionId: PropTypes.string,
  onSelect: PropTypes.func,
}

export default MultiColumnLinkPanel
